import { Col, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'

import hocFrom from '../../../components/forms/HocFrom'
import InputControl from '../../../components/inputs/InputControl'
import InputEditor from '../../../components/inputs/InputEditor'
import Switchrs from '../../../components/inputs/Switchrs'
import Loader from '../../../components/layout/Loader'


const FormCategoryQuestion = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {

    const handelValue = (name, value) => {
        if (name === "isActiveFormGroupQuestion") {
            handelsetdataForm({ ...formdata, isActive: value })
        }
        else {

            handelsetdataForm({ ...formdata, [name]: value })
        }
    }

    const handelSubmit = event => {
        event.preventDefault()

        handelLoadingform(true)

        if (!formdata.categoryId) {
            toast.error(' لطفا دسته  را  انتخاب کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.question) {
            toast.error(' لطفا سوال را وارد کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.answer) {
            toast.error(' لطفا جواب را وارد کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.question ? handelUpdataFrom() : handelSend()
        }
    }
    return (
        <>
            {
                loding ? <Loader />

                    : <Form>
                        <Form.Row>
                            <Col>
                                <InputControl url='/category/dropdown' label='گروه اصلی' name='categoryId' handelValue={handelValue} defaultValue={dataUpdate.groupId} />
                            </Col>

                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <Form.Label>سوال</Form.Label>
                                <Form.Control as="textarea" rows={2} name='question' onChange={e => handelValue('question', e.target.value)} defaultValue={dataUpdate.question} />
                            </Col>
                        </Form.Row>
                        <InputEditor label='جواب' name='answer' handelValue={handelValue} defaultValue={dataUpdate.answer} />
                        <Form.Row>
                            <Switchrs label='آیا فعال باشد؟' name='isActiveFormGroupQuestion' handelValue={handelValue} checked={formdata.isActive} />
                        </Form.Row>
                        <Form.Row>
                            <Col className='mt-3' >
                                <button type='submit' className='btn btn-success' onClick={handelSubmit} disabled={LoadingForm} >
                                    {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : dataUpdate.question ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>
                    </Form>
            }

        </>
    )
}

export default hocFrom(FormCategoryQuestion)
